import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import {LockPerson, Public} from '@mui/icons-material'

type DatasetVisibilityIconProps = {
    isPublic: boolean | null | undefined;
}

const DatasetVisibilityIcon = ({isPublic}: DatasetVisibilityIconProps) => {
    return (
        <Tooltip title={isPublic ? 'Public dataset' : 'Private dataset'} placement="top">
            {isPublic ? <Public/> : <LockPerson/>}
        </Tooltip>
    )
}

export default DatasetVisibilityIcon